import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { ChildFragment } from "@outschool/ui-auth";
import { FieldError } from "@outschool/ui-utils/src/useFormState";

import {
  ParentChildrenQuery as ParentChildrenQueryType,
  ParentChildrenQueryVariables
} from "../../../shared/generated/graphql";
import ActivityEnrollWithCharterPurchaseOrder from "../../components/enrolling/ActivityEnrollWithCharterPurchaseOrder";

const ParentChildrenQuery = gql`
  query ParentChildren($email: String!) {
    parentByEmail: user(uidOrEmail: $email) {
      uid
      name
      email
      otherEmailDetails {
        uid
        email
        confirmed_at
      }
      children {
        ...ChildFragment
      }
      enrollments {
        ...ActivityEnrollWithCharterPurchaseOrder_enrollment
      }
    }
  }
  ${ChildFragment}
  ${ActivityEnrollWithCharterPurchaseOrder.fragments.enrollment}
`;

export function useCharterParentChild(
  parentEmail: string | null | undefined,
  parentEmailErrors: FieldError[] | null | undefined
) {
  const { data: { parentByEmail } = {} } = useQueryWithPreviousData<
    ParentChildrenQueryType,
    ParentChildrenQueryVariables
  >(ParentChildrenQuery, {
    skip:
      (parentEmail || "").length === 0 || (parentEmailErrors || []).length > 0,
    variables: {
      email: parentEmail!
    },
    fetchPolicy: "network-only"
  });

  return parentByEmail;
}
